import { useState } from "react";
import { Link } from "react-router-dom";
import { blogPosts } from "../../../mocks/blogPosts";

const ALL_CATEGORIES = ["All", "History", "Behind the Counter", "Craft", "Culture"];

export default function BlogGrid() {
  const [activeCategory, setActiveCategory] = useState("All");

  const filtered = activeCategory === "All"
    ? blogPosts.slice(1)
    : blogPosts.slice(1).filter((p) => p.category === activeCategory);

  return (
    <div>
      {/* Category Tabs */}
      <div className="flex items-center gap-1 bg-black/5 rounded-full p-1 w-fit mb-10">
        {ALL_CATEGORIES.map((cat) => (
          <button
            key={cat}
            onClick={() => setActiveCategory(cat)}
            className={`px-4 py-1.5 rounded-full text-[11px] tracking-[0.15em] uppercase font-bold transition-all duration-200 cursor-pointer whitespace-nowrap ${
              activeCategory === cat
                ? "bg-black text-white"
                : "text-black/50 hover:text-black"
            }`}
            style={{ fontFamily: "'Barlow', sans-serif" }}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* Grid */}
      {filtered.length === 0 ? (
        <div className="text-center py-20">
          <p className="text-black/30 text-sm" style={{ fontFamily: "'Barlow', sans-serif" }}>
            No stories in this category yet.
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((post) => (
            <BlogCard key={post.id} post={post} />
          ))}
        </div>
      )}
    </div>
  );
}

function BlogCard({ post }: { post: typeof blogPosts[0] }) {
  return (
    <Link to={`/blog/${post.id}`} className="group block">
      <article className="bg-white rounded-sm overflow-hidden border border-black/8 hover:-translate-y-1 transition-all duration-300">
        <div className="relative w-full h-52 overflow-hidden bg-[#e8e8e8]">
          <img
            src={post.image}
            alt={post.title}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute bottom-0 left-0">
            <span
              className="bg-black text-white text-[10px] tracking-[0.2em] uppercase px-3 py-1.5 font-bold"
              style={{ fontFamily: "'Barlow', sans-serif" }}
            >
              {post.category}
            </span>
          </div>
        </div>
        <div className="p-6">
          <div className="flex items-center gap-3 mb-3">
            <span className="text-black/40 text-xs" style={{ fontFamily: "'Barlow', sans-serif" }}>{post.date}</span>
            <span className="w-1 h-1 bg-black/20 rounded-full" />
            <span className="text-black/40 text-xs" style={{ fontFamily: "'Barlow', sans-serif" }}>{post.readTime}</span>
          </div>
          <h3
            className="text-black font-bold text-lg leading-tight mb-3 group-hover:opacity-70 transition-opacity"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            {post.title}
          </h3>
          <p
            className="text-black/50 text-xs leading-relaxed mb-4 line-clamp-3"
            style={{ fontFamily: "'Barlow', sans-serif" }}
          >
            {post.excerpt}
          </p>
          <span
            className="text-black text-xs font-bold tracking-[0.15em] uppercase border-b border-black/30 pb-0.5 group-hover:border-black transition-colors flex items-center gap-1.5 w-fit"
            style={{ fontFamily: "'Barlow', sans-serif" }}
          >
            Read More
            <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center group-hover:translate-x-0.5 transition-transform duration-200"></i>
          </span>
        </div>
      </article>
    </Link>
  );
}
